mat-form-field{margin-right:10px}.cloud-attributes{display:inline-flex;gap:14px}mat-expansion-panel{max-width:90%}
/*# sourceMappingURL=generate-random-points.component.css.map */
